import { z } from 'zod';
import { opcional } from './comunes.js';
/**
 * Obra: el proyecto al que se imputa un requerimiento o una orden. Es dato
 * maestro compartido —sale como columna en dos reportes—, así que un duplicado
 * no molesta solo en el selector: parte las cifras en dos.
 *
 * Hasta ahora solo existían las de la semilla. Se abre el alta porque quien
 * topa con la obra faltante es justo quien la necesita, a mitad de una orden.
 */
export const obraEntrada = z.object({
    // El código sigue la convención del área (EST-MGRAU), no un correlativo: se
    // pide, no se inventa. Mayúsculas porque así están las que ya existen y una
    // lista mezclada se ordena mal.
    codigo: z.string().trim().min(2, 'El código es obligatorio').max(30)
        .transform((v) => v.toUpperCase()),
    nombre: z.string().trim().min(3, 'El nombre de la obra es obligatorio').max(200),
    ubicacion: opcional(z.string().trim().max(200)),
    activo: z.boolean().default(true),
});
/**
 * `.partial()` hace opcionales los campos pero NO elimina sus `.default()`: sin
 * volver a declarar `activo`, editar la ubicación reactivaría una obra
 * terminada. Es el mismo defecto que se corrigió en `empresaEdicion`.
 */
export const obraEdicion = obraEntrada.partial().extend({
    activo: z.boolean().optional(),
});
export const obra = z.object({
    id: z.number().int(),
    codigo: z.string(),
    nombre: z.string(),
    ubicacion: z.string().nullable(),
    activo: z.boolean(),
});
export const idObra = z.object({
    id: z.coerce.number().int().positive(),
});
//# sourceMappingURL=obra.js.map